'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiArrowMaximise = function TiArrowMaximise(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25 6.7c-0.9 0-1.7 0.7-1.7 1.6s0.8 1.7 1.7 1.7h2.6l-5.4 5.5c-0.7 0.6-0.7 1.7 0 2.3 0.3 0.4 0.7 0.5 1.1 0.5s0.9-0.1 1.2-0.5l5.5-5.4v2.6c0 0.9 0.7 1.7 1.7 1.7s1.6-0.8 1.6-1.7v-8.3h-8.3z m-9.5 15.5l-5.5 5.4v-2.6c0-0.9-0.7-1.7-1.7-1.7s-1.6 0.8-1.6 1.7v8.3h1.6l6.7 0c0.9 0 1.7-0.7 1.7-1.6s-0.8-1.7-1.7-1.7h-2.6l5.4-5.5c0.7-0.6 0.7-1.7 0-2.3s-1.7-0.7-2.3 0z m-3.8-2.2c0.9 0 1.6-0.7 1.6-1.7v-5h5c1 0 1.7-0.7 1.7-1.6s-0.7-1.7-1.7-1.7h-8.3l0 8.3c0 1 0.7 1.7 1.7 1.7z m16.6 0c-0.9 0-1.6 0.7-1.6 1.7v5h-5c-1 0-1.7 0.7-1.7 1.6s0.7 1.7 1.7 1.7h8.3v-8.3c0-0.9-0.7-1.7-1.7-1.7z' })
        )
    );
};

exports.default = TiArrowMaximise;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/arrow-maximise.js
// module id = 1787
// module chunks = 0